import {
  Component,
  computed,
  effect,
  EventEmitter,
  forwardRef,
  input,
  model,
  Output,
  signal,
} from "@angular/core";
import { ChipsComponent } from "../chips/chips.component";
import { MatLabel } from "@angular/material/form-field";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { SharedModule } from "../../shared.module";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { asapScheduler } from "rxjs";
import { ChipState } from "../../enums/chip-state.enum";

@Component({
  selector: "vl-select",
  standalone: true,
  imports: [
    ChipsComponent,
    MatLabel,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    SharedModule,
  ],
  templateUrl: "./select.component.html",
  styleUrl: "./select.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent {
  elements = input<{ name: string; value: any; tooltip?: string }[]>();
  highlightSelected = input(false);
  text = input<string>();
  iconLeft = input<string>();
  defaultColor = input<ChipState>("enabled");
  label = input<string>();
  customLabel = input<string>();
  disableLabel = input<boolean>(false);

  value = model<any>();

  buttonState = signal<ChipState>("enabled");
  selectedElement = computed(() => {
    if (!this.elements()) {
      return null;
    }
    const value = this.value();
    return this.elements().find((e) => e.value === value);
  });

  @Output() select = new EventEmitter();

  onChangeFn = (v) => {};
  onTouchFn = (v) => {};

  constructor() {
    effect(() => {
      if (
        !this.highlightSelected() &&
        this.selectedElement() &&
        this.defaultColor()
      ) {
        asapScheduler.schedule(() => this.buttonState.set(this.defaultColor()));
      } else {
        asapScheduler.schedule(() => this.buttonState.set("enabled"));
      }
    });
  }

  emitChanges() {
    this.onChangeFn(this.value());
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchFn = fn;
  }

  writeValue(value: any): void {
    asapScheduler.schedule(() => {
      this.value.set(value);
    });
  }

  selectElement(element: { name: string; value: any }) {
    this.value.set(element.value);
    this.emitChanges();
    this.select.emit(element.value);
  }

  onCloseMenu() {
    if (this.highlightSelected() && this.selectedElement()) {
      return;
    }
    this.buttonState.set("enabled");
  }

  onOpenMenu() {
    this.buttonState.set("active");
  }
}
